import { normalizeSchedulingKey } from '../ticketing/partner-scheduling-patterns.js';

/** Cells that belong to site appendix tables, not Region/Country index rows (`partner` handled via shouldStopIndexSheetAtRow) */
const NON_INDEX_HEADERISH = new Set([
  'sitename',
  'site',
  'sitedescription',
  'sitetype',
  'servicesperfor',
  'businessunits',
  'postalcode',
  'stateprov',
  'codeabbrev',
  'abbrev',
  'lan',
  'address',
]);

/**
 * Blank row, repeated "Region"/"Country" titles, or obvious non-geo header cells
 * (workbooks often insert spacer rows then a second table).
 */
export function shouldSkipNonIndexDataRow(region: string, country: string, city: string, address: string): boolean {
  const r = normalizeSchedulingKey(region);
  const c = normalizeSchedulingKey(country);
  const ci = normalizeSchedulingKey(city);
  const a = normalizeSchedulingKey(address);
  if (!r && !c && !ci && !a) return true;
  if (r === 'region' && c === 'country') return true;
  if (NON_INDEX_HEADERISH.has(r) || NON_INDEX_HEADERISH.has(c)) return true;
  return false;
}

/**
 * When Region/Country columns contain the next table's column title "PARTNER", stop parsing this sheet.
 */
export function shouldStopIndexSheetAtRow(region: string, country: string): boolean {
  const r = normalizeSchedulingKey(region);
  const c = normalizeSchedulingKey(country);
  return r === 'partner' || c === 'partner';
}
